import React from "react";
import { VariantProps } from ".";
import GetPriceByEmail from "./GetPriceByEmail";
import WhyDoWeDoThis from "./WhyWeDoThis";
import ContactUsForDetails from "./ContactUsForDetails";
import StandardPrice from "../StandardPrice";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";
const J = (props: VariantProps) => {
  const {
    price,
    unitOfMeasure,
    user,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    itemNumber,
    isGoogleView,
    mustBuy,
    minimumBuy,
    chatHours
  } = props;
  const isInternalUser = user.analyticsData?.is_on_vpn?.toLocaleUpperCase() === "YES";
  return <div className="map map-override mapJ" data-sentry-component="J" data-sentry-source-file="J.tsx">
      {isGoogleView ? <GoogleViewPrice price={price.price} minimumBuy={minimumBuy} mustBuy={mustBuy} /> : <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />}
      <ContactUsForDetails loginOverride={false} data-sentry-element="ContactUsForDetails" data-sentry-source-file="J.tsx" />
      <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} data-sentry-element="PlusShippingLevels" data-sentry-source-file="J.tsx" />
      <p className="to-see-price noborder mb-2">
        Call {user.platinum?.enabled ? "717-750-3826" : "717-392-7472"}
        <em>{chatHours}</em>
      </p>
      <p className="to-see-price" />
      {!price.hideWhyDoWeDoThis && <WhyDoWeDoThis type="contact" />}
      {isInternalUser && <GetPriceByEmail email={user.emailAddress} itemNumber={itemNumber} />}
    </div>;
};
export default J;